<template>
  <b-dropdown-item @click="show = true">
    <i class="ri-download-line mr-2" />
    {{ $t(`${tt}.title`) }}

    <b-modal
      v-model="show"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
      <template slot="modal-title">
        {{ $t(`${tt}.modal.title`) }}
      </template>

      <p v-html="$t(`${tt}.modal.description`)" />

      <div class="row">
        <div class="col-md-6">
          <label>{{ $t(`${tt}.modal.from`) }}:</label>
          <b-form-datepicker
            v-model="from"
            placeholder="From"
            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
            class="mb-2"
          />
        </div>
        <div class="col-md-6">
          <label>{{ $t(`${tt}.modal.to`) }}:</label>
          <b-form-datepicker
            v-model="to"
            :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"
            placeholder="To"
            class="mb-2"
          />
        </div>
      </div>
      <div class="bg-primary text-light" />
      <div
        slot="modal-footer"
        class="w-100 text-right"
      >
        <button
          type="button"
          class="btn ml-auto btn-primary btn-labeled btn-labeled-left"
          :class="{'disabled': disabled}"
          @click="onExport"
        >
          <b><i :class="iconDownload" /></b>
          {{ $t(`${tt}.modal.btn_submit`) }}
        </button>
      </div>
    </b-modal>
  </b-dropdown-item>
</template>

<script>
import axios from "axios";
import {alert} from '@pnotify/core';
import {formatYYYYMMDD} from "@/utils/dateTimeSameHuman";
import catchDispatch from "@/utils/catchDispatch";
import {exportTasksModal} from "../../../services/chat/event/onMessageDump";

export default {
  data() {
    const nowStartOfDay = new Date();
    nowStartOfDay.setUTCHours(0, 0, 0, 0);

    const from = new Date(nowStartOfDay);
    const to = new Date(nowStartOfDay);

    from.setDate(from.getDate() - 7);

    return {
      tt: 'rooms.export',
      show: false,
      disabled: false,
      from: formatYYYYMMDD(from),
      to: formatYYYYMMDD(to),
    };
  },
  computed: {
    iconDownload() {
      return this.disabled ? ['ri-loader-2-line', 'spinner'] : ['ri-download-line'];
    },
  },
  methods: {
    onExport() {
      if (this.disabled) return;
      this.disabled = true;

      const id = (new Date()).getTime();
      exportTasksModal[id] = alert({
        title: this.$t(`${this.tt}.alert.start.title`),
        text: '<div class="progress"><div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%"></div></div>',
        textTrusted: true,
        addClass: 'btn-primary',
        icon: 'ri-loader-2-line spinner',
        hide: false,
        closer: true,
      });

      axios
        .get(`/chats/api/v1/chats/export`, {
          params: {
            task: id,
            since: Date.parse(this.from) / 1000,
            until: Date.parse(this.to) / 1000 + 24 * 60 * 60 - 1,
          },
        })
        .then(() => this.show = false)
        .catch(e => catchDispatch.call(this, e))
        .finally(() => this.disabled = false);
    },
  },
}
</script>

<style scoped>

</style>
